<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9956 2.05408C6.50367 2.05408 2.04492 6.51279 2.04492 12.0048C2.04492 17.4966 6.50367 21.9555 11.9956 21.9555C17.4875 21.9555 21.9462 17.4966 21.9462 12.0048C21.9462 6.51279 17.4875 2.05408 11.9956 2.05408ZM11.9956 3.6388C16.6129 3.6388 20.3616 7.38742 20.3616 12.0048C20.3616 16.6221 16.6129 20.3707 11.9956 20.3707C7.37826 20.3707 3.62957 16.6221 3.62957 12.0048C3.62957 7.38742 7.37826 3.6388 11.9956 3.6388ZM7.35429 12.4103L10.1781 15.2342C10.4876 15.5436 10.9892 15.5436 11.2987 15.2342L16.6369 9.89591C16.9461 9.58665 16.9461 9.08453 16.6369 8.77538C16.3276 8.46612 15.8256 8.46612 15.5164 8.77538C15.5164 8.77538 12.1083 12.1834 10.7384 13.5534C9.91503 12.7301 8.47481 11.2898 8.47481 11.2898C8.16559 10.9806 7.6635 10.9806 7.35429 11.2898C7.04508 11.599 7.04508 12.1012 7.35429 12.4103Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Success'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
